import { render, staticRenderFns } from "./EmptyStatePlaceholder.vue?vue&type=template&id=07848571&scoped=true&"
import script from "./EmptyStatePlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyStatePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStatePlaceholder.vue?vue&type=style&index=0&id=07848571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07848571",
  null
  
)

export default component.exports